import { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import NextStepButton from "./components/button";
import PageLayout from "./components/layout/layout";
import { setBankHome } from "store/bank/action";

import { getHomeData } from "containers/card/services/service";
import { useAppContext } from "utils/context";

import Bullet from "./components/bullet";

import "./index.scss";

const CardPromotion = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { instance } = useAppContext();
  const [step, setStep] = useState("intro");
  const { promotion } = useSelector((state) => state?.bankReducer?.bank ?? {});

  const {
    background_image = "",
    bullets = [],
    color = "#000",
    description,
    images = [],
    line = {},
    title,
  } = promotion ?? {};

  const goBack = () => navigate(-1);

  const handleRenderBulletClassName = (item) => {
    switch (item) {
      case "top-right":
        return "top-[-38px] right-[40px] ";

      case "top-left":
        return "top-[-38px] left-[40px] ";

      case "bottom-center":
        return "translate-x-[-50%]  translate-y-[-30%] left-[50%]";

      case "bottom-right":
        return "bottom-[-10px] right-[30px] ";

      case "bottom-left":
        return "bottom-[-10px]  left-[30px]";

      default:
        return "";
    }
  };

  const fetchHomeData = useCallback(async () => {
    const response = await getHomeData(instance);
    if (response) {
      dispatch(setBankHome(response));
    }
  }, [instance, dispatch]);

  useEffect(() => {
    if ([undefined, null].includes(promotion)) fetchHomeData();
  }, [promotion]);

  const renderSteps = () => {
    switch (step) {
      case "bult":
        return (
          <div className="mx-0">
            <div className=" transition-all w-full  relative ">
              <div className="absolute top-12 ">
                <img src={background_image} title="card1" alt="card1" />
                <div className="line-1-h" />
                <div className="line-1-v" />
                <div className="line-2-h" />
                <div className="line-2-v" />
                <div className="line-3-h" />
                <div className="line-3-v" />
                <div className="line-4 translate-x-[-50%] left-[50%]" />
                <div className="line-5-h" />
                <div className="line-5-v" />
                {bullets.map((el) => (
                  <Bullet
                    key={el.title}
                    backgroundColor={line.background_color}
                    className={handleRenderBulletClassName(el.position)}
                    color={color}
                    imgSrc={el.icon}
                    lineColor={line.color}
                    title={el.title}
                  />
                ))}
              </div>
            </div>
            <div className="mx-5">
              <NextStepButton
                onNext={() => {
                  navigate("/card");
                }}
              />
            </div>
          </div>
        );

      case "intro":
      default:
        return (
          <div className="mx-5">
            <div className="transition-all w-full h-[360px] relative ">
              <div className="absolute left-1/4 md:left-1/3   top-1/3 w-full  ">
                {images.map((el, index) => (
                  <img
                    className={`card${index + 1} `}
                    src={el}
                    title="کارت"
                    alt="کارت"
                  />
                ))}
              </div>
            </div>

            <h2 style={{ color: color }} className="mb-4 display-demibold ">
              {title}
            </h2>
            <p style={{ color: color }} className="mb-4 body-14px-regular">
              {description}
            </p>

            <NextStepButton onNext={() => setStep("bult")} />
          </div>
        );
    }
  };

  return <PageLayout goBack={goBack}>{renderSteps()}</PageLayout>;
};

export default CardPromotion;
